import gql  from 'graphql-tag';


export const UPDATE_CATEGORY = gql`
    mutation updateCategory($categoryId:String! $categoryName:String!){
        updateCategory(categoryId:$categoryId categoryName:$categoryName){
            id
            categoryName
        }
    }
`
